<template>
  <div data-module="hiring">
    <div class="headline">
      <div data-ornament="rectangle"/>
      <h1 v-html="heading" />
    </div>
    <div class="intro">
      <p v-html="teaser"></p>
    </div>
    <template v-if="haveJobs">
    <div class="listings">
      <ul>
        <li v-for="listing in data.listings" :key="listing.jobTitle">
          <a :href="listing.listingURL" rel="external" target="_blank">
            {{listing.jobTitle}}
          </a>
          <p class="description">{{listing.description}}</p>
        </li>
      </ul>
    </div>
    </template>
    <template v-else>
    <div class="no-listings">
      <router-link v-bind:to="{ path: '/contact#contact-us-form' }" class="no-hover">
        <mouse-event-container>
          <router-link v-bind:to="{ path: '/contact#contact-us-form' }" class="link--underline">
            Drop us a line
          </router-link>
          <p v-html="noJobsContent" />
        </mouse-event-container>
      </router-link>
    </div>
    </template>
  </div>
</template>

<script>
// Components
import MouseEventContainer from '@/components/MouseEventContainer';

export default {

  name: 'HiringComponent',

  components: { MouseEventContainer },

  props: ['data'],

  computed: {

    heading() {
      const heading = this.data.heading;
      if (this.haveJobs) {
        return heading.jobs;
      }
      return heading.noJobs;
    },

    teaser() {
      const teaser = this.data.teaser;
      if (this.haveJobs) {
        return teaser.jobs;
      }
      return teaser.noJobs;
    },

    noJobsContent() {
      return this.data.noJobsContent;
    },

    haveJobs() {
      return (this.data.listings.length > 0);
    },

  },

};
</script>


<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="hiring"] {
  @include grid($subgrid: true, $rows: 2);
  @include spacer();

  .headline {
    grid-row: 1;
    grid-column: 1 / 8;
  }

  .intro {
    grid-row: -1;
    grid-column: 1 / span 5;
  }

  .listings {
    grid-row: -1;
    grid-column: 7 / span 6;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    a {
      font-size: rem(20px);
    }
  }

  .no-listings {
    grid-row: -1;
    grid-column: 7 / span 6;
    // position: relative;
    // top: -5rem;

    a {
      font-weight: 400;
    }

    .hover--active a {
      text-decoration: underline;
    }

    p {
      @include type('default', $color--primary-dark);
      font-size: $layout--base-font-size;
      margin: 0 0 1rem 0;
    }
  }

  h1 {
    @include type('h1-default');
  }

  [data-ornament] {
    display: block;
    margin-bottom: rem(30px);
    width: rem(80px);
  }

  @include mq($bp--tablet, down) {
    grid-template-rows: repeat(3, auto);

    .headline {
      grid-row: 1;
      grid-column: 1 / 7;
    }
  }

  @include mq($bp--mobile, down) {
    grid-template-rows: repeat(3, auto);

    .headline {
      grid-row: 1;
      grid-column: 1 / -1;
    }

    .intro {
      grid-row: 2;
      grid-column: 1 / -1;
    }

    .listings {
      grid-row: 3;
      grid-column: 1 / -1;
    }

    .no-listings {
      grid-row: -1;
      grid-column: 1 / -1;
      // position: initial;
      // top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/hiring.vue